<div>
    <div class="title">
        <h3> <strong>Información del Conjunto:</strong> </h3>
    </div>
    <div class="container cont div-box-shadow">
        <div class="row">
            <div class="col-md-4 info">
                Nombre:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Nombre :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Nombre_Completo'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Tipo:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Tipo :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Tipo'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Sector:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Sector_Etapa :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Sector_Etapa'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Etapa:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Etapa :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Etapa'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row" *ngFor="let reso of resoluciones">
            <div class="col-md-4 info">
                Resolución:
            </div>
            <div class="col-md-6">
                {{ reso['Conj_Hab_Resoluciones::CHRS_Resol_Num'] }} -- {{
                reso['Conj_Hab_Resoluciones::CHRS_Resol_Fecha'] }} -- {{ reso['Conj_Hab_Resoluciones::CHRS_Resol_Tipo']
                }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row" *ngFor="let perm of permisos">
            <div class="col-md-4 info">
                Permiso:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? perm['Conj_Hab_Permiso::CHP_Perm_Num'] : perm['Conj_Hab_Permiso 2::CHP_Perm_Num']}} --
                {{
                detalleTotem ? perm['Conj_Hab_Permiso::CHP_Perm_Fecha_Otorgado'] : perm['Conj_Hab_Permiso
                2::CHP_Perm_Fecha_Otorgado']}} -- {{ detalleTotem ? perm['Conj_Hab_Permiso::CHP_Perm_Tipo'] :
                perm['Conj_Hab_Permiso 2::CHP_Perm_Tipo']
                }} <a style="cursor: pointer;" (click)="downloadDocument(detalleTotem ? infoDetalle.portalData.Conj_Hab_Permiso[0]['Conj_Hab_Permiso::CHP_Ruta_Base_Final'] :
                infoDetalle.portalData['Conj_Hab_Permiso 2'][0]['Conj_Hab_Permiso 2::CHP_Ruta_Base_Final'])">Ver
                    permiso</a>
                <!-- Falta campo para archivol -->
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row" *ngFor="let rece of recepcion">
            <div class="col-md-4 info">
                Recepción:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? rece['Conj_Hab_Recepciones::CHRP_Recep_Numero'] : rece['Conj_Hab_Recepciones
                2::CHRP_Recep_Numero']}} -- {{
                detalleTotem ? rece['Conj_Hab_Recepciones::CHRP_Fecha'] : rece['Conj_Hab_Recepciones 2::CHRP_Fecha']}}
                -- {{ detalleTotem ? rece['Conj_Hab_Recepciones::CHRP_Tipo'] : rece['Conj_Hab_Recepciones 2::CHRP_Tipo']
                }} <a style="cursor: pointer;"
                    (click)="downloadDocument(detalleTotem ? infoDetalle.portalData.Conj_Hab_Recepciones[0]['Conj_Hab_Recepciones::CHRP_Ruta_Base_Final'] :
                infoDetalle.portalData['Conj_Hab_Recepciones 2'][0]['Conj_Hab_Recepciones 2::CHRP_Ruta_Base_Final'])">Ver Recepción</a>
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Propiedades:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData['ConjHab_Predios Copiar'] :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Predios Copiar'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Plano de Loteo:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Nombre :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Nombre_Completo'] }} {{ detalleTotem ?
                infoDetalle.fieldData.ConjHab_Sector_Etapa : ""}} <a style="cursor: pointer;"
                    (click)="downloadDocument(detalleTotem ? infoDetalle.portalData['Conj_Hab_Planos_Loteo'][0]['Conj_Hab_Planos_Loteo::CHPL_Ruta_Base_Plano_Ver'] :
                    infoDetalle.portalData.Conj_Hab_Planos_Loteo[0]['Conj_Hab_Planos_Loteo::CHPL_Ruta_Base_Plano_Ver'])">Ver
                    Plano de loteo</a>
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Plano de Arquitectura:
            </div>
            <div class="col-md-6">
                {{ detalleTotem ? infoDetalle.fieldData.ConjHab_Nombre :
                infoDetalle.fieldData['Conjunto_Habitacional::ConjHab_Nombre'] }} <a style="cursor: pointer;" (click)="downloadDocument(detalleTotem ? infoDetalle.portalData.Conj_Hab_Planos[0]['Conj_Hab_Planos::CHP_Ruta_Base_Plano_Ver'] :
                infoDetalle.portalData.Conj_Hab_Planos[0]['Conj_Hab_Planos::CHP_Ruta_Base_Plano_Ver'])">Ver plano de
                    Arquitectura</a>
            </div>
            <hr style="border-top: 1px solid">
        </div>
    </div>
</div>